//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/Builder.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
let d=[[[0,"CellCountX",1,0],[0,"CellCountY",1,0],[0,"CellCountZ",1,0],[0,"FileBrowser",1,0],[0,"GridLineCount",1,0],[0,"KeepRods",1,0],[0,"RodDiameter",1,0],[0,"RodItemList",0,"GeometricUtilities.RodItemListBuilder",0],[0,"ShowGrid",1,0],[0,"ShowPattern",1,0]],[[["section"],"Open",{R_:{numberOfSegments:''}},1,0],[[],"Save",{},0,0],[[],"CreateWorkingCube",{},0,0],[[],"CreateSnapHandles",{},0,0]],[]];
SPLM.Features.UnitCellEditorBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.UnitCellEditorBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;